import React, { useRef, useState, useEffect } from 'react';
import CTAButton from "../Common/CTAButton";

function Plans({ pricing, country }) {
    const [plan, setPlan] = useState("monthly");

    const containerRef = useRef(null);
    const [currentPlan, setCurrentPlan] = useState("");
    const [startX, setStartX] = useState(null);
    const [endX, setEndX] = useState(null);

    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        if (startX !== null) {
            setEndX(e.touches[0].clientX);
        }
    };

    const handleTouchEnd = () => {
        if (startX !== null && endX !== null) {
            const deltaX = endX - startX;
            const sensitivity = 50;

            if (deltaX > sensitivity) {
                setCurrentPlan("");
            } else if (deltaX < -sensitivity) {
                setCurrentPlan("right");
            }

            setStartX(null);
            setEndX(null);
        }
    };

    useEffect(() => {
        const listItems = document.querySelectorAll('.plan-switch .option');
        listItems.forEach(item => {
            item.addEventListener("click", function () {
                listItems.forEach(item => {
                    item.classList.remove('active');
                });
                item.classList.add('active');

                setPlan(item.dataset.value);
            });
        });

    }, []);
    return (
        <div className="plans-container">
            <h2>Select a Plan</h2>
            <div className="plan-switch">
                <span className={`option option-1 ${plan === "monthly" ? "active" : ""}`} data-value="monthly">Monthly</span>
                <span className={`option option-2 ${plan === "annual" ? "active" : ""}`} data-value="annual">Annual</span>
                <span className="bg"></span>
            </div>
            <div className="cards-container">
                <div
                    ref={containerRef}
                    className={`cards-slider ${currentPlan}`}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className="card">
                        {
                            process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) >= 0 &&
                            <h4>Standard</h4>
                        }
                        {
                            process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) < 0 &&
                            <h4>Standard*</h4>
                        }
                        <p className={`discount ${plan === "annual" ? "active" : ""}`}>Get up to 25% off on Annual plan</p>
                        {
                            pricing?.standard?.monthly && plan === "monthly" &&
                            <p className="pricing">{pricing?.standard?.monthly}*</p>
                        }
                        {
                            pricing?.standard?.annual && plan === "annual" &&
                            <p className="pricing">{pricing?.standard?.annual}*</p>
                        }
                        <p>Limited Ads</p>
                        <p>Full content library</p>
                        <p>24/7 Streaming Channels and Live Programs</p>
                        <p>Video quality in SD and HD</p>
                        {
                            process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) >= 0 &&
                            <p>Watch on up to three (3) devices at a time</p>
                        }
                        {
                            process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) < 0 &&
                            <p>Watch on up to three (3) devices at a time**</p>
                        }
                    </div>
                    <div className="separator"></div>
                    <div className="card">
                        <h4>Premium</h4>
                        <p className={`discount ${plan === "annual" ? "active" : ""}`}>Get up to 25% off on Annual plan</p>
                        {
                            pricing?.premium?.monthly && plan === "monthly" &&
                            <p className="pricing">{pricing?.premium?.monthly}*</p>
                        }
                        {
                            pricing?.premium?.annual && plan === "annual" &&
                            <p className="pricing">{pricing?.premium?.annual}*</p>
                        }
                        <p>Ad-Free Viewing</p>
                        <p>Full content library</p>
                        <p>24/7 Streaming Channels and Live Programs</p>
                        <p>Video quality in SD and HD</p>
                        {
                            process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) >= 0 &&
                            <p>Watch on up to four (4) devices at a time</p>
                        }
                        {
                            process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) < 0 &&
                            <p>Watch on up to four (4) devices at a time**</p>
                        }
                    </div>
                </div>
                <div className="mobile-dot">
                    <div className={`dot ${currentPlan === "" ? "active" : ""}`}></div>
                    <div className={`dot ${currentPlan !== "" ? "active" : ""}`}></div>
                </div>
            </div>
            <CTAButton context="Select a Plan" />
            {
                process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) >= 0 &&
                <p className="disclaimer">
                    *Plus applicable taxes and charges in some countries/locations.
                </p>
            }
            {
                process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) >= 0 &&
                <p className="disclaimer">
                    Save up to 25% off the regular monthly price for a 12-month subscription.
                </p>
            }
            {
                process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) < 0 &&
                <p className="disclaimer">
                    *Standard Plan not available in the Philippines
                </p>
            }
            {
                process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(country) < 0 &&
                <p className="disclaimer">
                    **Limited to 2 concurrent devices in the Philippines
                </p>
            }
        </div>
    );
}

export default Plans;